<template lang="pug">
  .profile-page__main
    .profile-page__header
      .profile-page__title
        h1.title {{ title }}
    .profile-page__body
      section.profile-page-form__section.profile-section
        .profile-section__body
          .profile-page-form
            section.profile-page-form__section.profile-section
              .profile-section__title
                h2.profile-section-title Общая информация
              .profile-section__body
                .form
                  .form__elem
                    .form-elem.form-elem_horizontal(
                      :class="{'form-elem_error':fieldsErrors.campName}"
                    )
                      .form-elem__title Название
                      .form-elem__body
                        input.input.input_full(
                        maxlength="128"
                        v-model="fields.campName"
                        @input="resetError('campName')"
                        )
                  .form__elem
                    .form-elem.form-elem_horizontal(
                    :class="{'form-elem_error':fieldsErrors.campManager}"
                    )
                      .form-elem__title Директор
                      .form-elem__body
                        multiselect.custom-multiselect(
                          v-model="fields.campManager"
                          placeholder="Введите имя или email директора",
                          :options="managersList"
                          :id="'value'"
                          :label="'text'"
                          :multiple="false"
                          :showLabels="false"
                          :closeOnSelect="true"
                          :allowEmpty="false"
                          @select="changeCampManagerValue"
                        )
                          template(
                            slot="noOptions"
                          ) Список пуст
                          template(
                            slot="noResult"
                          ) Ничего не найдено
                        //simple-select-form(
                        //:list-data="managersList"
                        //:default-value="fields.campManager"
                        //@onChangeDefaultValue="changeCampManagerValue"
                        //type="campManager"
                        //:specificChoice="true"
                        //)
                  .form__elem
                    .form-elem.form-elem_horizontal
                      .form-elem__title Центр Распределения Путевок
                      .form-elem__body
                        input.input.input_full(
                        maxlength="128"
                        v-model="fields.vdc"
                        disabled="disabled"
                        )
            section.profile-page-form__section.profile-section
              .profile-section__body
                .form
                  .form__elem.form__elem_button
                    .form-elem
                      .form-elem__body
                        button.button.button_paint-main(
                        @click="onSaveCamp()"
                        )
                          .button__text {{buttonText}}
                      .form-elem__error(v-show="showErrorInfo") Не все поля заполнены

</template>

<script>
import {mapActions} from "vuex";
import AdminMixin from "../../mixins/admin-mixin.js";
import SimpleSelectForm from "../../../../../components/simpleSelectForm/SimpleSelectForm";
import {CampManagerFilterEnums} from "../../../../../const/index.js";
import Multiselect from "vue-multiselect";

export default {
  name: "AdminCampEditor",
  components: {SimpleSelectForm, Multiselect},
  mixins: [
    AdminMixin
  ],
  data() {
    return {
      managersList: [],
      fields: {
        campName: "",
        campManager: {
          value: null,
          text: "Выберите из списка"
        },
        vdc: ""//центр распределения путевок
      },
      fieldsErrors: {
        campName: false,
        campManager: false
      },
      showErrorInfo: ""
    };
  },
  computed: {
    mode() {
      if (this.$route.params.id === "create") {
        return "create";
      }
      return "edit";
    },
    campId() {
      if (this.$route.params.id) {
        return this.$route.params.id;
      }
      return null;
    },
    title() {
      if (this.mode === "edit") {
        return "Редактирование лагеря";
      }
      return "Создание лагеря";
    },
    buttonText() {
      if (this.mode === "edit") {
        return "Сохранить";
      }
      return "Создать лагерь";
    }
  },
  methods: {
    ...mapActions(["getCampManagers", "createCamp", "getCamp", "updateCamp"]),
    changeCampManagerValue(data) {
      this.fields.vdc = data.campgroup.name;
      this.resetError("campManager");
    },
    resetError(field) {
      this.fieldsErrors[field] = false;
      this.showErrorInfo = "";
    },
    validation() {
      const errors = [];
      if (this.fields.campName.length === 0) {
        this.fieldsErrors.campName = true;
        errors.push("campName");
      }
      if (this.fields.campManager.value === null) {
        this.fieldsErrors.campManager = true;
        errors.push("campManager");
      }
      if (errors.length > 0) {
        return false;
      }
      return true;
    },
    onSaveCamp() {
      if (!this.validation()) {
        this.showErrorInfo = true;
        return;
      }
      const data = {
        name: this.fields.campName,
        director: this.fields.campManager.value
      };
      if (this.mode === "edit") {
        this.updateCamp({
          id: this.campId,
          data: data
        }).then((res) => {
          if (res.status === 200) {
            this.campData = res.data;
            this.$root.$emit("onShowNotificationModal", {
              text: "Лагерь обновлен"
            });
          } else {
            this.$root.$emit("onShowErrorModal", {
              text: `${res.status} ошибка`
            });
          }
        });
      } else {
        this.createCamp(data).then(res => {
          if (res.status === 201) {
            this.$router.push({name: "AdminCampsRegistry"});
            this.$root.$emit("onShowNotificationModal", {
              text: "Лагерь создан"
            });
          } else {
            alert(res.status);
          }
        });
      }
    },
    setFields(campData) {
      this.fields.campName = campData.name;
      this.fields.campManager = this.managersList.find((item) => {
        return item.value === campData.director;
      });
      this.fields.vdc = this.fields.campManager.campgroup.name;
    }
  },
  created() {
    this.$root.$emit("on-show-preloader");
  },
  mounted() {
    const _this = this;
    const getCampManagersPromise = new Promise((resolve, reject) => {
      _this.getCampManagers().then(res => {
        _this.managersList = res.map(item => {
          return {
            value: item.id,
            text: `${_this.setDirectorName(item)} (${item.email})`,
            campgroup: item.campgroup
          };
        });
        resolve();
      });
    });
    getCampManagersPromise.then(() => {
      if (this.mode === "edit") {
        this.getCamp(this.campId).then(res => {
          this.setFields(res);
          this.$root.$emit("on-hide-preloader");
        });
      } else {
        this.$root.$emit("on-hide-preloader");
      }
    });
  }
};
</script>
